/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PopupViews } from '@/defines/EnumDefine'
import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { base } from '@/base/base'
import { log, error, isSameDay } from '@/utils/functions'

// 优先级，数字越小越优先
const VIEW_PRIORITY = {
  //[PopupViews.RegisterBindPhonePanel]: 1,
  [PopupViews.BindingPhonePanel]: 1,
  [PopupViews.SignPanel]: 2,
  [PopupViews.PinDuoShowPopPanel]: 3,
  [PopupViews.TurnTablePanel]: 4,
  [PopupViews.RankRewardPanel]: 5,
  [PopupViews.VipRewardPanel]: 6,
  [PopupViews.PinDuoPopPanel]: 7,
  [PopupViews.PayWheelPanel]: 8,
  [PopupViews.WelcomePopPanel]: 9,
  [PopupViews.VipCardPanel]: 10,
  [PopupViews.VipConversionPanel]: 11,
  [PopupViews.NewBindActivityPanel]: 12,
  [PopupViews.FirstDepositPanel]: 13,
  [PopupViews.WaterWheelPanel]: 14,
  [PopupViews.BonanzaPanel]: 15,
  [PopupViews.FreeSpinViewX]: 16,
  [PopupViews.DailyTaskPanel]: 17,
  [PopupViews.BindingBeforePanel]: 18,
  [PopupViews.JackpotgamsPanel]: 19,
}

// priority number 优先级，数字越小越优先
// overlap true：可以在该弹窗关闭的时候再弹出下一个弹窗；false:不允许弹窗叠加，**该字段已弃用，弹窗改成可以连续弹出
// dailyCount 每天可弹出次数，不限制填 99999 即可
const VIEW_INFOS = {
  SignPanel: {
    name: 'SignPanel',
    overlap: true,
    dailyCount: 1,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('SignPanel', ...args)
    },
  },

  VipCardPanel: {
    name: 'VipCardPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('VipCardPanel', ...args)
    },
  },

  RankRewardPanel: {
    name: 'RankRewardPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('RankRewardPanel', ...args)
    },
  },

  VipRewardPanel: {
    name: 'VipRewardPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('VipRewardPanel', ...args)
    },
  },

  PayWheelPanel: {
    name: 'PayWheelPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('PayWheelPanel', ...args)
    },
  },

  VipConversionPanel: {
    name: 'VipConversionPanel',
    overlap: true,
    dailyCount: 1,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('VipConversionPanel', ...args)
    },
  },

  WelcomePopPanel: {
    name: 'WelcomePopPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('WelcomePopPanel', ...args)
    },
  },

  NewBindActivityPanel: {
    name: 'NewBindActivityPanel',
    overlap: true,
    dailyCount: 1,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('NewBindActivityPanel', ...args)
    },
  },

  TurnTablePanel: {
    name: 'TurnTablePanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('TurnTablePanel', ...args)
    },
  },

  PinDuoPopPanel: {
    name: 'PinDuoPopPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('PinDuoPopPanel', ...args)
    },
  },

  // RegisterBindPhonePanel: {
  //     name: "RegisterBindPhonePanel",
  //     overlap: true,
  //     dailyCount: 99999,
  //     showView: (...args: any[]) => {
  //         base.uiHudSystem.show("RegisterBindPhonePanel", ...args);
  //     }
  // },

  BindingPhonePanel: {
    name: 'BindingPhonePanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('BindingPhonePanel', ...args)
    },
  },

  PinDuoShowPopPanel: {
    name: 'PinDuoShowPopPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('PinDuoShowPopPanel', ...args)
    },
  },

  FirstDepositPanel: {
    name: 'FirstDepositPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('FirstDepositPanel', ...args)
    },
  },

  WaterWheelPanel: {
    name: 'WaterWheelPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('WaterWheelPanel', ...args)
    },
  },

  BonanzaPanel: {
    name: 'BonanzaPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('BonanzaPanel', ...args)
    },
  },

  FreeSpinViewX: {
    name: 'FreeSpinViewX',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('FreeSpinViewX', ...args)
    },
  },

  DailyTaskPanel: {
    name: 'DailyTaskPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('DailyTaskPanel', ...args)
    },
  },

  BindingBeforePanel: {
    name: 'BindingBeforePanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('BindingBeforePanel', ...args)
    },
  },

  JackpotgamsPanel: {
    name: 'JackpotgamsPanel',
    overlap: true,
    dailyCount: 99999,
    showView: (...args: any[]) => {
      base.uiHudSystem.show('JackpotgamsPanel', ...args)
    },
  },
}

type PopupCountData = {
  count: number
  lastTime: number
}

type PopupData = {
  name: string
  params: any
}

export class PopupViewModule extends ModuleBase {
  popupList: PopupData[] = []
  _pause: boolean = true
  isInShow: boolean = false

  _lastPopupName: string | null = null
  _allPopupTried: boolean = false

  viewPopupCountData: Map<string, PopupCountData> = new Map()

  isFirstAdd = false

  init(): void {
    for (const key in VIEW_INFOS) {
      const info = VIEW_INFOS[key]
      let priority = VIEW_PRIORITY[info.name]
      if (priority == null) {
        error('can not find view in VIEW_PRIORITY: ' + info.name)
        priority = 99
      }
      info.priority = priority
    }

    this._reinit()
  }

  _reinit() {
    this.popupList = []
    this._pause = true
    this.isInShow = false
    this._lastPopupName = null
  }

  onClear(): void {
    this._reinit()
  }

  onLoad(): void {
    hall.eventDispatcher.on(hall.EventDefine.PopupEndToNext, this.onPopupEndToNext, this)
    hall.eventDispatcher.on(hall.EventDefine.TryAddPopupView, this.onTryAddPopupView, this)
  }

  onDestroy(): void {
    hall.eventDispatcher.off(hall.EventDefine.PopupEndToNext, this.onPopupEndToNext, this)
    hall.eventDispatcher.off(hall.EventDefine.TryAddPopupView, this.onTryAddPopupView, this)
  }

  onPreloadData(): void {}

  inits2c(): void {}

  suspend(): void {
    console.log('PopupViewManager:suspend')
    this._pause = true
    this.isInShow = false
  }

  resume(languageChanged: boolean = false): void {
    console.log('PopupViewManager:resume')
    this._pause = false
    this.isInShow = false
    this._lastPopupName = null

    if (!languageChanged) {
      this.popupView()
    }
  }

  popupView(): void {
    log('PopupViewManager:popupView() _pause', this._pause, this.popupList.length)
    log('PopupViewManager:popupView() isInShow =', this.isInShow)

    if (this._pause || this.isInShow) {
      log('PopupViewManager:popupView() return by is pause', this._pause, this.isInShow)
      return
    }

    if (this.popupList.length === 0) {
      hall.eventDispatcher.emit(hall.EventDefine.AllPopupViewClose)
      return
    }

    // 检查是否在大厅界面
    const hallPanel = base.uiHudSystem.getFromActiveHud('HallPanel')
    if (!hallPanel) {
      log('PopupViewManager:popupView() return by is not in HallPanel')
      return
    }

    const data = this.popupList[0]
    this.popupList.splice(0, 1)

    this._lastPopupName = data.name
    this._addPopupCount(data.name)

    this.showView(data.name, ...data.params)

    this.isInShow = true
  }

  addPopupView(name: string, ...params: any[]): void {
    log('PopupViewManager:addPopupView() name =', name, ...params)
    log('PopupViewManager:addPopupView() name =', name, this._pause, this.popupList.length)

    // if (this.popupList.length >= 5) {
    //     log("too much popup view");
    // }

    // Remove duplicate popup
    for (let i = this.popupList.length - 1; i >= 0; i--) {
      if (this.popupList[i].name === name) {
        this.popupList.splice(i, 1)
        log('remove repeated popup view:', name)
      }
    }

    if (!this._checkDailyCount(name)) {
      log('view can not popup twice in same day:', name)
      return
    }

    const data = { name: name, params: params }
    this.popupList.push(data)

    this.sortViews_()
    this.popupView()
  }

  sortViews_(): void {
    this.popupList.sort((a, b) => {
      const aPriority = VIEW_INFOS[a.name]?.priority ?? 99
      const bPriority = VIEW_INFOS[b.name]?.priority ?? 99
      return aPriority - bPriority
    })
  }

  onPopupEndToNext(noShowNext?: boolean): void {
    log('PopupViewManager:onPopupEndToNext() noShowNext =', noShowNext)
    this.isInShow = false

    if (noShowNext) {
      hall.eventDispatcher.emit(hall.EventDefine.AllPopupViewClose)
      return
    }

    this.popupView()
  }

  onTryAddPopupView(_tag: string): void {
    const BindActivityPanel = base.uiHudSystem.getFromActiveHud('NewBindActivityPanel', true)
    if (this.popupList.length != 0 || BindActivityPanel != null) {
      return
    }
    this.tryAddAllPopup()
  }

  _addPopupCount(name: string): void {
    let data = this.viewPopupCountData[name]
    if (data == null) {
      data = this._loadPopupCountData(name)
    }

    data.count = data.count + 1
    data.lastTime = Date.now()

    const key = this._getPopupCountDataKey(name)
    localStorage.setItem(key, JSON.stringify(data))
  }

  _checkDailyCount(name: string): boolean {
    let data = this.viewPopupCountData[name]
    if (data == null) {
      data = this._loadPopupCountData(name)
    }

    const viewInfo = VIEW_INFOS[name]
    if (viewInfo.dailyCount >= 99999) {
      return true
    }

    if (isSameDay(Date.now(), data.lastTime)) {
      return data.count < viewInfo.dailyCount
    } else {
      return true
    }
  }

  _loadPopupCountData(name: string): PopupCountData {
    const key = this._getPopupCountDataKey(name)

    const dataStr = localStorage.getItem(key)
    if (dataStr != null && dataStr != '') {
      const data = JSON.parse(dataStr)
      // 不是同一天，重置次数
      if (!isSameDay(Date.now(), data.lastTime)) {
        data.count = 0
        data.lastTime = 0
      }

      return data
    }

    return { count: 0, lastTime: 0 }
  }

  _getPopupCountDataKey(name: string): string {
    const uid = hall.userModule.userId || 0
    return `${name}_PopupCountData_${uid}`
  }

  showView(name: string, ...args: any[]): void {
    log('PopupViewManager:showView() name =', name, ...args)
    const info = VIEW_INFOS[name]
    if (info && info.showView) {
      info.showView(...args)
    }
  }

  tryAddAllPopup(): void {
    if (this._allPopupTried) {
      log('PopupViewManager:tryAddAllPopup() is _allPopupTried = ', this._allPopupTried)
      return
    }

    //if (!this._isGetAllPopupDatas()) {
    //    log("PopupViewManager:tryAddAllPopup() all popup data is not geted.");
    //    return;
    //}

    ////判断是不是pwa
    //if (!window.matchMedia('(display-mode: standalone)').matches) {
    //    log("NotPwaNow");
    //    return;
    //}

    const isBind = hall.userModule.hasBoundPhoneNum()
    const goodsInfo = hall.addCashModule.getGoodsInfos()
    const isHaveGoodInfo = goodsInfo && goodsInfo.first_pay == 1

    if (!isBind && isHaveGoodInfo) {
      //未绑定 + 未首充
      hall.signModule.popupView()
      hall.hallModule.popupView()
      hall.turnTableModule.popupView()
      hall.addCashModule.popupFirstView()
      hall.pinDuoModule.popupOpenView()
      //hall.bindActivityModule.popupView()
    } else if (!isBind && !isHaveGoodInfo) {
      //未绑定 + 首充
      hall.hallModule.popupView()
      hall.signModule.popupView()
      hall.turnTableModule.popupView()
      hall.pinDuoModule.popupOpenView()
      //hall.bindActivityModule.popupView()
      hall.vipDailyCashModule.popupView()
      //hall.rankModule.popupView()
    } else if (isBind && isHaveGoodInfo) {
      //绑定 + 未首充
      hall.signModule.popupView()
      hall.turnTableModule.popupView()
      hall.addCashModule.popupFirstView()
      hall.pinDuoModule.popupOpenView()
      //hall.bindActivityModule.popupView()
      //hall.rankModule.popupView()
    } else if (isBind && !isHaveGoodInfo) {
      //绑定  + 首充
      hall.signModule.popupView()
      hall.turnTableModule.popupView()
      hall.pinDuoModule.popupOpenView()
      // hall.bindActivityModule.popupView()
      hall.vipDailyCashModule.popupView()
      //hall.rankModule.popupView()
    }
    // // 根据优先级调整代码的先后顺序
    // hall.hallModule.popupView()
    // hall.signModule.popupView()
    // hall.pinDuoModule.popupOpenView()
    // hall.turnTableModule.popupView()
    // hall.rankModule.popupView()
    // hall.vipEquityModule.popupView()
    // hall.pinDuoModule.popupView()
    // hall.bindActivityModule.popupView()
    // //hall.addCashModule.popupView()
    // //hall.vipModule.popupView()
    // //hall.vipDailyCashModule.popupView()
    this.isFirstAdd = true
    this._allPopupTried = true
    //this.onPopupEndToNext()
  }

  _isGetAllPopupDatas() {
    let geted = hall.signModule.isGetedPopupData()
    if (!geted) {
      log('_tryPopupSignPanel return by not get data signModule')
      return false
    }

    geted = hall.vipModule.isGetedPopupData()
    if (!geted) {
      log('_tryPopupSignPanel return by not get data vipModule')
      return false
    }

    geted = hall.vipDailyCashModule.isGetedPopupData()
    if (!geted) {
      log('_tryPopupSignPanel return by not get data vipDailyCashModule')
      return false
    }

    geted = hall.addCashModule.isGetedPopupData()
    if (!geted) {
      log('_tryPopupSignPanel return by not get data addCashModule')
      return false
    }

    geted = hall.vipEquityModule.isGetedPopupData()
    if (!geted) {
      log('_tryPopupSignPanel return by not get data vipEquityModule')
      return false
    }

    return true
  }
}
